import Quill from 'quill';

///
export const QuillVideoWatch: any = {
    watcher: {},
    active: null,
    on: function (videoExtendId: any, VideoExtend: any) {
        if (!this.watcher[videoExtendId]) {
            this.watcher[videoExtendId] = VideoExtend;
        }
    },
    emit: function (activeId: any, type = 1) {
        this.active = this.watcher[activeId];
        if (type === 1) {
            videoHandler();
        }
    }
};

/**
* @description Extens�o para manipula��o de v�deos
*/
export class VideoExtend {
    private quill: any;
    private config: any;
    private file: string;
    private videoURL: string;
    private id: number;
    private cursorIndex: number;

    /**
     * @param quill {Quill}
     * @param config {Object} options
     * config  keys: action, headers, editForm start end error  size response
     */
    constructor(quill: any, config = {}) {
        this.id = Math.random();
        this.quill = quill;
        this.quill.id = this.id;
        this.config = config;
        this.file = '';
        this.videoURL = '';
        quill.root.addEventListener('paste', this.pasteHandle.bind(this), false);
        quill.root.addEventListener('drop', this.dropHandle.bind(this), false);
        quill.root.addEventListener('dropover', function (e: any) { e.preventDefault(); }, false);
        this.cursorIndex = 0;
        QuillVideoWatch.on(this.id, this);
    }

    /**
     * @description Manipula 'PASTE'
     * @param e
     */
    pasteHandle(e: any) {
        // e.preventDefault()
        QuillVideoWatch.emit(this.quill.id, 0);
        const clipboardData = e.clipboardData;
        let i = 0;
        let items, item, types;

        if (clipboardData) {
            items = clipboardData.items;

            if (!items) {
                return;
            }
            item = items[0];
            types = clipboardData.types || [];

            for (; i < types.length; i++) {
                if (types[i] === 'Files') {
                    item = items[i];
                    break;
                }
            }
            if (item && item.kind === 'file' && item.type.match(/^image\//i)) {
                this.file = item.getAsFile();
                const self: any = this;
                // 
                if (self.config.size && self.file.size >= self.config.size * 1024 * 1024) {
                    if (self.config.sizeError) {
                        self.config.sizeError();
                    }
                    return;
                }
                if (this.config.action) {
                    // this.uploadVideo()
                } else {
                    // this.toBase64()
                }
            }
        }
    }

    /**
     *  @description Manipula DROP
     * @param e
     */
    dropHandle(e: any) {
        QuillVideoWatch.emit(this.quill.id, 0);
        const self: any = this;
        e.preventDefault();
        // 
        if (self.config.size && self.file.size >= self.config.size * 1024 * 1024) {
            if (self.config.sizeError) {
                self.config.sizeError();
            }
            return;
        }
        self.file = e.dataTransfer.files[0];
        if (this.config.action) {
            self.uploadVideo();
        } else {
            self.toBase64();
        }
    }

    /**
     * @description Converte para Base64
     */
    toBase64() {
        const self: any = this;
        const reader = new FileReader();
        reader.onload = (e) => {
            self.videoURL = e.target.result;
            self.insertVideo();
        };
        reader.readAsDataURL(self.file);
    }

    /**
     * @description Envia arquivo
     */
    uploadVideo() {
        const self: any = this;
        const config = self.config;
        //
        const formData = new FormData();
        formData.append(config.name, self.file);
        //
        if (config.editForm) {
            config.editForm(formData);
        }
        //
        const xhr = new XMLHttpRequest();
        xhr.open('post', config.action, true);
        //
        if (config.headers) {
            config.headers(xhr);
        }
        if (config.change) {
            config.change(xhr, formData);
        }
        xhr.onreadystatechange = function () {
            if (xhr.readyState === 4) {
                if (xhr.status === 200) {
                    //success
                    const res = JSON.parse(xhr.responseText);
                    self.videoURL = config.response(res);
                    QuillVideoWatch.active.uploadSuccess();
                    self.insertVideo();
                    if (self.config.success) {
                        self.config.success();
                    }
                } else {
                    //error
                    if (self.config.error) {
                        self.config.error();
                    }
                    QuillVideoWatch.active.uploadError();
                }
            }
        };
        //
        xhr.upload.onloadstart = function (e) {
            QuillVideoWatch.active.uploading();
            if (config.start) {
                config.start();
            }
        };
        //
        xhr.upload.onprogress = function (e) {
            const complete = (e.loaded / e.total * 100 | 0) + '%';
            QuillVideoWatch.active.progress(complete);
        };
        //
        xhr.upload.onerror = function (e) {
            QuillVideoWatch.active.uploadError();
            if (config.error) {
                config.error();
            }
        };
        //
        xhr.upload.onloadend = function (e) {
            if (config.end) {
                config.end();
            }
        };
        xhr.send(formData);
    }

    /**
     * @description Insere o v�deo no editor
     */
    insertVideo() {
        const self = QuillVideoWatch.active;
        self.quill.insertEmbed(QuillVideoWatch.active.cursorIndex, 'videoUrl', self.videoURL);
        self.quill.update();
        self.quill.setSelection(self.cursorIndex + 1);
    }

    /**
     * @description Exibe o progresso
     */
    progress(pro: any) {
        pro = '[' + 'enviando ' + pro + ']';
        QuillVideoWatch.active.quill.root.innerHTML
            = QuillVideoWatch.active.quill.root.innerHTML.replace(/\[enviando.*?\]/, pro);
    }

    /**
     * @description Manipula In�cio upload
     */
    uploading() {
        const length = (QuillVideoWatch.active.quill.getSelection() || {}).index || QuillVideoWatch.active.quill.getLength();
        QuillVideoWatch.active.cursorIndex = length;
        QuillVideoWatch.active.quill.insertText(QuillVideoWatch.active.cursorIndex, '[enviando...]', { 'color': 'red' }, true);
    }

    /**
     * @description Manipula Erro de upload
     */
    uploadError() {
        QuillVideoWatch.active.quill.root.innerHTML
            = QuillVideoWatch.active.quill.root.innerHTML.replace(/\[enviando.*?\]/, '[upload error]');
    }

    /**
     * @description Manipula upload completado
     */
    uploadSuccess() {
        QuillVideoWatch.active.quill.root.innerHTML
            = QuillVideoWatch.active.quill.root.innerHTML.replace(/\[enviando.*?\]/, '');
    }
}

/**
* @description 
*/
export function videoHandler() {
    let fileInput: any = document.querySelector('.quill-video-input');
    if (fileInput === null) {
        fileInput = document.createElement('input');
        fileInput.setAttribute('type', 'file');
        fileInput.setAttribute('accept', 'video/mp4');
        fileInput.classList.add('quill-video-input');
        fileInput.style.display = 'none';
        // 
        fileInput.addEventListener('change', function () {
            const self = QuillVideoWatch.active;
            self.file = fileInput.files[0];
            fileInput.value = '';
            // 
            if (self.config.size && self.file.size >= self.config.size * 1024 * 1024) {
                if (self.config.sizeError) {
                    self.config.sizeError();
                }
                return;
            }
            if (self.config.action) {
                self.uploadVideo();
            } else {
                self.toBase64();
            }
        });
        document.body.appendChild(fileInput);
    }
    fileInput.click();
}


Quill.register('modules/VideoExtend', VideoExtend);